module.exports = __webpack_public_path__ + "static/img/TB1.3117edbc.png";